module.exports = __webpack_public_path__ + "static/media/bunkey-avatar-22.65f614f2.png";